import React, { FC } from 'react'
import UserRolesContainer from 'containers/UserRoles'

const UserRolesPage: FC = () => <UserRolesContainer />

export default UserRolesPage
